import logo from './logo.svg';
import './App.css';
import AppRoutes from './Routes/appRoutes';
function App() {

    return (
      <>
    <AppRoutes/>
    </>
  );
}

export default App;
